import { render } from "./Conformity.vue?vue&type=template&id=80a0110c"
import script from "./Conformity.vue?vue&type=script&lang=js"
export * from "./Conformity.vue?vue&type=script&lang=js"

import "./Conformity.vue?vue&type=style&index=0&id=80a0110c&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__